module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {

	var _ = {
		hideNotice: function (nList) {
			if (nList === undefined) {
				nList = this.rwom1('#noticeContainer #notices');
			}

			$(nList.getRowNode(1)).addClass('slide-up');

			setTimeout(fox.bind(nList.remove, nList), 500);
		},

		showMainNotice: function (params) {
			var
				noticeContainer = this.wom1('#noticeContainer'),
				noticeList
			;

			if (!noticeContainer) {
				noticeContainer = this.embedWidget('noticeContainer', 'Widget', {
					autoRender: true,
					template: params.noticeContainerTemplate || 'div>div#notice-main-container',
					embed: {
						container: params.noticeContainer || '#header',
						location: 'above'
					},
					'widgets.notices': {
						widget: 'AdvancedList',
						'embed.container': params.noticeEmbedContainer || '#notice-main-container',
						'tpl.row': params.noticeTemplate || 'div>h2{$[message]}',
						'hooks.onStopRendering': fox.bind(function () {
							var
								$h = $(this.dom1('#header')),
								$n = $(this.rwom1('#noticeContainer #notices').getRowNode(1));

							if (($h.length && $(document).scrollTop() > $h.height()) || !$h.length) {
								$n.addClass('without-header');
							} else {
								$(window).bind('scroll', function () {
									var st = $(document).scrollTop();

									if (st < $h.height()) {
										$n.css('top', st * -1);
									} else {
										$n.css('top', '-70px')
									}
								})
							}
						}, this),
						'handleDom.closeNotice': {
							event: 'click',
							target: '.notice-close',
							callback: function () {
								_.hideNotice(noticeList);
							}
						}
					}
				});

				noticeContainer.run();
			}

			noticeList = noticeContainer.rwom1('#notices');

			if (noticeList.getLength() === 1) {
				noticeList.updateItem({
					type: params.noticeType,
					message: params.noticeMessage
				}, 1);
			} else if (noticeList.getLength() < 1) {
				noticeList.appendItem({
					type: params.noticeType,
					message: params.noticeMessage
				});
			}

			if (fox.isNumeric(params.delayClose)) {
				setTimeout(function () {
					_.hideNotice(noticeList);
				}, params.delayClose);
			}
		},

		getTranslation: function(alias) {
			var translation = {
				'uploadFailedWrongFileFormat': fox.i18n.getTranslation('uploadFailedWrongFileFormat', 'The upload has failed. Please make sure you are uploading a supported file type:', 'notifications'),
				'messageSuccessfullySent': fox.i18n.getTranslation('messageSuccessfullySent', 'Your message(s) was successfully sent.', 'notifications')
			};

			return translation[alias] || '';
		}
	};

	fox.registerWidget('BaseMain', {

		showNotice: function (params) {
			return _.showMainNotice.call(this, params);
		},

		hideNotice: function (nw) {
			return _.hideNotice.call(this, nw);
		},

		configure: function () {
			this.registerOptions('', {
				handleWom: {
					newMessagesCount: {
						event: 'cameNewMessages',
						widget: '@root #newMessageCount',
						'params.prefix': 'formessagecounter',
						callback: function (data) {
							var mn = this.dom1('.notifier.messages');

							if (fox.dom.isDomNode(mn)) {
								mn.innerHTML = data.total > 0 ? ['+', data.total].join('') : '';
							}
						}
					},
					fileOnUploadIsValid: {
						event: 'fileIsValid',
						widget: '~.Form_Element_FileUploaderInterface',
						callback: fox.bind(function () {
							var
								nList = this.wom1('#noticeContainer #notices');

							if (nList && nList.getLength()) {
								this.hideNotice(nList);
							}
						}, this)
					},
					fileOnUploadNotValid: {
						event: 'fileNotValid',
						widget: '~.Form_Element_FileUploaderInterface',
						callback: fox.bind(function (params) {
							var data = {
								noticeMessage: [_.getTranslation('uploadFailedWrongFileFormat') + ' ', params.validExt.join(', ')].join(''),
								noticeType: 'error',
								noticeTemplate: 'new_notice'
							};

							if (this.getClass() === 'Layout_Organize') {
								data.noticeContainer = '.wrapper-organize';
							}

							this.showNotice(data);
						}, this)
					},
					fileOnUploadNotValidFromUploads: {
						event: 'wrongFileTypes',
						widget: '~.Editor_Uploads',
						callback: fox.bind(function (params) {
							var data = {
								noticeMessage: [_.getTranslation('uploadFailedWrongFileFormat') + ' ', params.validExt.join(', ')].join(''),
								noticeType: 'error',
								noticeTemplate: 'new_notice'
							};

							_.showMainNotice.call(this, data);
						}, this)
					},
					messageSuccessfullySend: {
						event: 'messageSended',
						widget: '~.Popup_NewMessage',
						callback: fox.bind(function () {
							var data = {
								noticeMessage: _.getTranslation('messageSuccessfullySent'),
								noticeType: 'success',
								noticeTemplate: 'new_notice',
								delayClose: 8000
							};

							_.showMainNotice.call(this, data);
						}, this)
					}
				}
			});

			this.callParent('configure', arguments);
		}

	}, 'Site_Layout');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/layout/baseMain.js
// module id = 464
// module chunks = 2